import logoHero from './images/logo-hero.svg'
import logoFooter from './images/logo-footer.svg'
import heroOverlay from './images/hero-overlay.svg'
import heroOverlayMobile from './images/hero-overlay-mobile.svg'
import teamAndrew from './images/team-andrew.png'
import teamJonathan from './images/team-jonathan.png'
import teamRobert from './images/team-robert.png'
import teamShane from './images/team-shane.png'
import iconLinkedInDefault from './images/icon-linkedin-default.svg'
import iconLinkedInColored from './images/icon-linkedin-colored.svg'
import industryRetail from './images/industries/retail-ecommerce.webp'
import industryFinance from './images/industries/finance-insurance.webp'
import industryHealthcare from './images/industries/healthcare-life-sciences.webp'
import industryHigherEd from './images/industries/higher-education.webp'
import industryRetailWork from './images/industries/retail_agent.webp'
import industryFinanceWork from './images/industries/finance_agent.webp'
import industryHealthcareWork from './images/industries/healthcare_agent.webp'
import industryHigherEdWork from './images/industries/highered_agent.webp'

export const imageAssets = {
  logo: {
    hero: logoHero,
    footer: logoFooter,
  },
  hero: {
    overlay: heroOverlay,
    overlayMobile: heroOverlayMobile,
  },
  team: {
    members: [teamAndrew, teamRobert, teamJonathan, teamShane],
  },
  icons: {
    linkedIn: {
      default: iconLinkedInDefault,
      colored: iconLinkedInColored,
    },
  },
  industries: {
    retailEcommerce: industryRetail,
    financeInsurance: industryFinance,
    healthcareLifeSciences: industryHealthcare,
    higherEducation: industryHigherEd,    
    retailEcommerceWork: industryRetailWork,
    financeInsuranceWork: industryFinanceWork,
    healthcareLifeSciencesWork: industryHealthcareWork,
    higherEducationWork: industryHigherEdWork,
  },
}
